module.exports = __webpack_public_path__ + "img/ic_logout.526854df.svg";